import { useState } from "react";
import LoginForm from "./components/LoginForm";
import SignUpForm from "./components/SignUpForm";
import Icon from "../../components/AppIcon";
import { Link } from "react-router-dom";

const LoginPage = () => {
  const [view, setView] = useState("login"); // 'login' or 'signup'

  const toggleView = () => {
    setView(view === "login" ? "signup" : "login");
  };

  return (
    <div className="min-h-screen flex bg-white">
      {/* Left Side - Visual */}
      <div className="hidden lg:flex lg:w-1/2 bg-slate-900 relative overflow-hidden items-center justify-center p-12">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-900 opacity-90" />
        <img
          src="https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80"
          alt="Volunteering"
          className="absolute inset-0 w-full h-full object-cover mix-blend-overlay opacity-50"
        />

        <div className="relative z-10 text-white max-w-xl">
          <Link to="/" className="inline-flex items-center gap-2 mb-12 hover:opacity-80 transition">
            <div className="bg-white/20 p-2 rounded-lg backdrop-blur-sm">
              <Icon name="Heart" size={24} className="text-white" />
            </div>
            <span className="text-2xl font-bold tracking-tight">VolunteerHub</span>
          </Link>

          <h1 className="text-5xl font-bold mb-6 leading-tight">
            {view === 'login' ? 'Turn your passion into action.' : 'Join the movement today.'}
          </h1>
          <p className="text-xl text-blue-100 leading-relaxed mb-8">
            {view === 'login'
              ? 'Connect with organizations, track your impact, and be part of a community making a real difference.'
              : 'Create an account to start finding opportunities, logging hours, and earning recognition for your work.'
            }
          </p>

          <div className="flex gap-4">
            <div className="bg-white/10 backdrop-blur-md p-4 rounded-xl border border-white/20 flex-1">
              <div className="text-3xl font-bold mb-1">10k+</div>
              <div className="text-blue-200 text-sm">Volunteers</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md p-4 rounded-xl border border-white/20 flex-1">
              <div className="text-3xl font-bold mb-1">150k+</div>
              <div className="text-blue-200 text-sm">Hours Logged</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center p-8 lg:p-24 relative">
        <Link to="/" className="absolute top-8 left-8 lg:hidden flex items-center gap-2 text-slate-900 font-bold">
          <Icon name="ArrowLeft" size={20} /> Back
        </Link>

        {view === "login" ? (
          <LoginForm onToggleMode={toggleView} />
        ) : (
          <SignUpForm onToggleMode={toggleView} />
        )}
      </div>
    </div>
  );
};

export default LoginPage;
